import findAll from 'Helpers/findAll';
import Resource from './Resource';

export type Error = object | null;

export type Metadata = {
	limit: number;
	offset: number;
	total: number;
	// Set by SQL list routes when `total` is a capped floor.
	hasMore?: boolean;
};

export default class ResourceTyped<
	GetType,
	ListType = GetType,
	SaveType = Partial<GetType>,
	MetadataSave = Metadata,
	ReturnType = { data: GetType; metadata?: MetadataSave; error: Error }
> extends Resource {
	eventName?: string;
	merge?(data: { from: number | number[]; to: number; name: string }): Promise<ReturnType>;

	find(filters = {}, opts = {}): Promise<{ data: ListType[]; metadata: Metadata; error: Error }> {
		return super.find(filters, opts);
	}

	get(id: number | string, opts = {}): Promise<{ data: GetType; metadata?: Metadata; error: Error }> {
		return super.get(id, opts);
	}

	async save(data: SaveType, opts = {}): Promise<ReturnType> {
		return super.save(data, opts);
	}

	async delete(id: number, opts = {}, changedAttributeKeys = {}): Promise<ReturnType> {
		return super.delete(id, opts, changedAttributeKeys);
	}

	findAll(filters = {}, limit?: number) {
		return findAll(this.find, filters, limit);
	}

	count(filters = {}): Promise<number> {
		return super.count(filters);
	}

	/** Protected methods */
	async _afterSave(data: SaveType, opts = {}): Promise<ReturnType> {
		return super._afterSave(data, opts);
	}

	async _afterDelete(id: number, opts = {}): Promise<ReturnType> {
		return super._afterDelete(id, opts);
	}

	map(data: SaveType) {
		return super.map(data);
	}

	parse(data: any) {
		return super.parse(data) as GetType;
	}
}
